import { render, staticRenderFns } from "./DigitalDeliveryCheckboxField.vue?vue&type=template&id=201deb8e"
import script from "./DigitalDeliveryCheckboxField.vue?vue&type=script&lang=js"
export * from "./DigitalDeliveryCheckboxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports